






















import { Component, Mixins } from "vue-property-decorator";
import { DomainRegistry } from "../../domain";

@Component({
  components: {
  },
})
export default class RegisterNewAccountEntryView extends Mixins() {
  data() {
    return {
      isProcessing: false,
      isCompleted: false,
      accountCode: "",
    };
  }
  isProcessing: boolean;
  isCompleted: boolean;
  accountCode: string;

  async entry(): Promise<void> {
    try {
      if (!this.accountCode) {
        this.$warn("アカウント登録メール送信", "IDを入力してください。");
        return;
      }
      // TODO: メールアドレスの正規表現はさらに厳密にする余地がある
      if (!/^[a-zA-Z0-9_.+-]+@[a-zA-Z0-9_.+-]+$/.test(this.accountCode)) {
        this.$warn("アカウント登録メール送信", "IDにメールアドレスを入力してください。");
        return;
      }
      this.isProcessing = true;
      const repo = DomainRegistry.account.getUnauthenticatedAccountRepository();
      const result = await repo.registerNewAccountEntry(this.accountCode);
      if (result.isAlreadyRegistered) {
        this.$warn("アカウント登録メール送信", "すでに登録されているIDのため、登録できません。");
        return;
      }
      if (result.isMailSendFailed) {
        this.$warn("アカウント登録メール送信", "メール送信処理中にエラーが発生しました。");
        return;
      }
      if (!result.isOk) {
        this.$warn("アカウント登録メール送信", "処理できませんでした。");
        return;
      }
      this.$success("アカウント登録メール送信", "確認メールを送信しました。");
      this.isCompleted = true;
    } catch (e) {
      this.$error("アカウント登録メール送信", "処理中にエラーが発生しました。", e);
    } finally {
      this.isProcessing = false;
    }
  }

  moveToLoginView(): void {
    this.$router.replace({
      path: "/Login",
    });
  }
}
